<template>
  <div class="lebot-info" :class="type">
    <i class="fa small mr-1" :class="type ? `fa-${type}` : 'fa-info-circle'"></i>
    {{text}}
  </div>
</template>

<script>
export default {
  name: "LebotInfo",
  props: ['text','type']
}
</script>

<style scoped>
.lebot-info {
  font-size: 13px;
  background-color: #CBF2EE;
  padding: 6px 20px 7px;
  box-shadow: 0 1px 1px rgba(11,20,26,.13);
  border-radius: 7px;
  margin-bottom: 4px;
  text-align: center;
  font-weight: 400;
  color: var(--dark);
}
.lebot-info.exclamation-triangle {
  background-color: #ffd279 !important;
}

@media (max-width: 767px) {
  .lebot-info {
    padding: 10px 12px;
    margin-bottom: 8px;
  }
}
</style>